import * as React from "react";
const IconCenterAlign3 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M61 31h-8.5v-8.8c0-3.2-2.6-5.7-5.7-5.7h-2.1c-3.2 0-5.7 2.6-5.7 5.7V31H25.1V15.7c0-3.2-2.6-5.7-5.7-5.7h-2.1c-3.2 0-5.7 2.6-5.7 5.7V31H3c-.6 0-1 .4-1 1s.4 1 1 1h8.5v15.3c0 3.2 2.6 5.7 5.7 5.7h2.1c3.2 0 5.7-2.6 5.7-5.7V33h13.8v8.8c0 3.2 2.6 5.7 5.7 5.7h2.1c3.2 0 5.7-2.6 5.7-5.7V33H61c.6 0 1-.4 1-1s-.4-1-1-1M23.1 48.3c0 2.1-1.7 3.7-3.7 3.7h-2.1c-2.1 0-3.7-1.7-3.7-3.7V15.7c0-2.1 1.7-3.7 3.7-3.7h2.1c2.1 0 3.7 1.7 3.7 3.7zm23.7-2.8h-2.1c-2.1 0-3.7-1.7-3.7-3.7V22.2c0-2.1 1.7-3.7 3.7-3.7h2.1c2.1 0 3.7 1.7 3.7 3.7v19.5c0 2.1-1.7 3.8-3.7 3.8" />
  </svg>
);
export default IconCenterAlign3;
